import { DropdownFillers, NameAndIDType } from "../types";

export class CacheElement {
  private elements: NameAndIDType[] = [];

  public getElements(): NameAndIDType[] {
    return this.elements;
  }

  public setElements(elements: NameAndIDType[]): void {
    this.elements = elements;
  }

  public addElement(element: NameAndIDType): NameAndIDType[] {
    this.elements = [...this.elements, element];
    return this.elements;
  }

  public deleteElement(id: number): NameAndIDType[] {
    const newElements: NameAndIDType[] = [];
    for (const element of this.elements) {
      if (element.id !== id) {
        newElements.push(element);
      }
    }
    this.elements = newElements;
    return newElements;
  }

  public getDropdowns(placeholder?: string): DropdownFillers[] {
    const returnArray: DropdownFillers[] = [];
    if (placeholder) {
      returnArray.push({ key: 0, text: placeholder, value: 0 });
    }
    const count = 1;
    for (const element of this.elements) {
      returnArray.push({ key: count, value: element.id, text: element.name });
    }
    return returnArray;
  }
}
